





































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';

@Component({
    components: {},
    watch: {
        dealers: function (val) {
            (this as any).selected = val;
        }
    }
})
export default class Dealers extends ListBase {
    entity: string = 'dealer';
    selected: Array<any> = [0];
    red: any = 0;

    get loading() {
        return this.$store.state.dealer.loading;
    }

    get list() {
        if (!this.isDealer) {
            return [
                { id: 0, name: 'Todos' },
                ...this.$store.state.dealer.activeList
            ];
        } else
            return this.$store.state.dealer.activeList;
    }

    get listReds() {
        let list = [
            { id: 0, name: 'Todos' }
        ];

        list.push(...Util.abp.list.getList('D_TYPES'));

        return list;
    }

    get dealers() {
        return this.$store.state.app.dealers;
    }

    get isDealer() {
        return Util.abp.session.isDealer();
    }

    getInitials(string) {
        return Util.getInitials(string);
    }

    changeDealer(ids) {
        if (ids.length > 1) {
            if (ids[ids.length - 1] == 0)
                this.selected = [0]
            else
                this.selected = ids.filter(i => { return i > 0 });
        }
        this.$store.commit('app/setDealer', this.selected);
    }

    changeRed(id) {
        this.$store.commit('dealer/setRed', id);
        this.$store.commit('app/setRed', id);
    }

    async mounted() {
        if (!this.isDealer) {
            await this.$store.dispatch({
                type: 'dealer/getAllActive'
            });
            this.selected = [0];
        } else {
            this.selected = [Util.abp.session.dealers[0]];
            await this.$store.dispatch({
                type: 'dealer/getAllActive',
                data: { dealers: Util.abp.session.dealers}
            });
            this.$store.commit('app/setDealer', [Util.abp.session.dealers[0]]);
            //await this.$store.dispatch({
            //    type: 'dealer/get',
            //    id: Util.abp.session.dealerId
            //});
        }

        this.red = 0;
    }

    created() {
        if (this.isDealer) {
            this.selected = [Util.abp.session.dealers[0]];
            this.$store.commit('app/setDealer', Util.abp.session.dealers[0]);
        }
    }
}